import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { HomePage } from './screen/HomePage';
import { AboutMePage } from './screen/AboutMePage';
import { ProjectsPage } from './screen/ProjectsPage';
import { ContactPage } from './screen/ContactPage';
import { NoAccessPage } from './screen/NoAccessPage';
import { ImpressumPage } from './screen/ImpressumPage';
import { PrivacyPolicyPage } from './screen/PrivacyPolicyPage';

const StudioPage = lazy(() => import('./screen/StudioPage').then((module) => ({ default: module.StudioPage })));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-engin-kaya" element={<AboutMePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route
            path="/studio"
            element={
              <Suspense fallback={null}>
                <StudioPage />
              </Suspense>
            }
          />
          <Route path="/no-access" element={<NoAccessPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
